// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R0KF","left":"styles_left__1u6SP","desktopActions":"styles_desktopActions__2ttRD","title":"styles_title__TiI3F"};